<template>
  <div class="list-aside-menu">
    <div class="tc-15-search tc-15-multi-search">
      <div class="search-input-wrap">
        <input :placeholder="$t('core.search')" type="text" class="tc-15-search-words" v-model="keyword">
        <a v-if="keyword" href="javascript:;" role="button" class="btn-rm-txt" :title="$t('core.clear')"
          @click="keyword=''">{{$t('core.clear')}}</a>
        <button class="tc-15-btn weak m search"></button>
      </div>
    </div>
    <div class="aside-menu-container" @click.stop="onSwitchBucket">

      <!-- 收藏路径 -->
      <div class="aside-menu-item" :class="{'active':accessPathShow}" v-if="filterPathList.length">
        <div class="aside-menu-content" @click="accessPathShow=!accessPathShow;">
          <i class="menu-icon-link"></i>
          <span class="title">{{$t('core.collection_path')}}</span>
          <a href="javascript:;" class="icon-arrow-down"></a>
        </div>
        <transition name="fade">
          <ul class="aside-menu-list" v-if="accessPathShow">
            <li v-for="(item,index) in filterPathList" :key="`accessPath-${index}`" :class="{'active':checked===index}"
              :data-info="JSON.stringify({item,index,type:'path'})">
              <span :title="item.Path">{{item.Path}}</span>
            </li>
          </ul>
        </transition>
      </div>

      <!-- 存储桶 -->
      <div class="aside-menu-item" :class="{'active':bucketShow}" v-if="filterBucketList.length">
        <div class="aside-menu-content" @click="bucketShow=!bucketShow;">
          <i class="menu-icon-bucket"></i>
          <span class="title">{{$t('core.root')}}</span>
          <a href="javascript:;" class="icon-arrow-down"></a>
        </div>
        <transition name="fade">
          <ul class="aside-menu-list" v-if="bucketShow && filterBucketList.length">
            <li v-for="(item,index) in filterBucketList" :key="`bucket-${index}`"
              :class="{'active':checked===filterPathList.length+index}"
              :data-info="JSON.stringify({item,index,type:'bucket'})">
              <span :title="item.Bucket">{{item.Bucket}}</span>
            </li>
          </ul>
        </transition>

      </div>
    </div>
  </div>
</template>

<script>
import menu from '@/scripts/helper/menu';
import { tips } from '@/scripts/tools/utils';

export default {
  data() {
    return {
      loading: false,
      accessPathShow: true,
      bucketShow: true,
      pathList: [],
      bucketList: [],
      keywordTimer: 0,
      keywordDelay: this.$store.sideBarSearchKey,
    };
  },
  computed: {
    keyword: {
      get() {
        return this.$store.sideBarSearchKey;
      },
      set(val) {
        this.$store.sideBarSearchKey = val;
      },
    },
    showSideBar() {
      if (this.$store.showSideBar) {
        this.pullList();
      }
      return this.$store.showSideBar;
    },
    currPrefix() {
      const { crumbs } = this.$store;

      const currPrefix = crumbs.reduce((res, item, index) => {
        if (index > 0) {
          res += `${item.name}/`;
        }
        return res;
      }, '');
      return currPrefix;
    },
    currCrumb() {
      const { crumbs } = this.$store;
      return crumbs[crumbs.length - 1];
    },
    currSelectBucket() {
      const list = [...this.filterPathList, ...this.filterBucketList];
      if (!list.length || this.$store.checkedSideBar < 0) {
        return '';
      }
      return (
        list[this.$store.checkedSideBar].Path
        || list[this.$store.checkedSideBar].Bucket
      );
    },
    checked: {
      get() {
        const { crumbs } = this.$store;
        if (crumbs.length === 1) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.$store.checkedSideBar = -1;
        } else if (this.$store.checkedSideBar > -1 && crumbs[1]) {
          const currSelectBucket = crumbs[1].name;
          if (!this.currPrefix.includes(currSelectBucket)) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$store.checkedSideBar = -1;
          }
        }
        return this.$store.checkedSideBar;
      },
      set(val) {
        this.$store.checkedSideBar = val;
      },
    },
    filterBucketList() {
      return this.bucketList.filter(item => item.Bucket.includes(this.keywordDelay));
    },
    filterPathList() {
      return this.pathList.filter(item => item.Path.includes(this.keywordDelay));
    },
  },
  watch: {
    showSideBar(val) {
      this.$mutations.saveStore();
      if (val) {
        this.pullList();
      }
    },
    keyword(val) {
      // 延迟过滤列表
      if (this.keywordTimer) {
        clearTimeout(this.keywordTimer);
      }
      this.keywordTimer = setTimeout(() => {
        this.checked = -1;
        this.keywordDelay = val;
        this.keywordTimer = 0;
      }, 500);
    },
  },
  methods: {
    pullList() {
      let lastData = menu.getLastData();
      const result = lastData.result || {};
      if (result.message || result.allow) {
        this.pathList = lastData.pathInfo.pathList || [];
        this.bucketList = lastData.bucketList || [];
        return;
      }

      this.loading = true;
      tips.loading(window.lang.t('core.loading'));
      menu.getList(data => {
        const message = data.result && data.result.message;
        if (message) {
          tips.error(message);
        }

        lastData = menu.getLastData();
        this.pathList = lastData.pathInfo.pathList || [];
        this.bucketList = lastData.bucketList || [];
        tips.closeTips();
        this.loading = false;
      });
    },
    onSwitchBucket(e) {
      let { target } = e;
      if (target.dataset && !target.dataset.info) {
        target = target.parentNode;
      }
      if (!target.dataset.info) return;

      const info = JSON.parse(target.dataset.info);
      // eslint-disable-next-line prefer-const
      let { index, item, type } = info;
      index += type === 'bucket' ? this.filterPathList.length : 0;

      this.checked = index;

      const { Bucket, Region } = item;
      if (!Bucket) {
        tips.error(window.lang.t('error.bucket_not_selected'));
        return;
      }
      tips.closeTips();
      tips.loading(window.lang.t('core.loading'));

      this.$router
        .push({ name: 'file', query: { bucket: Bucket, region: Region } })
        .catch(() => {
          tips.closeTips();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.list-aside-menu {
  .aside-menu-content {
    cursor: pointer;
    &:hover {
      background-color: #eef1f5;
    }
  }

  .aside-menu-list {
    padding: 10px;
    li {
      cursor: pointer;
      padding-left: 24px;
      &:hover {
        background-color: #eef1f5;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
